import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, Shield, CheckCircle, Sparkles, ArrowRight } from 'lucide-react';
import Image from '../ui/Image';

export default function Hero() {
  return (
    <section className="relative overflow-hidden">
      <div className="container-responsive section-spacing">
        <div className="max-w-4xl mx-auto text-center content-spacing">
          <h1 className="h1">
            Create Your Professional Resume
            <span className="block mt-2 bg-gradient-to-r from-teal-600 to-teal-500 bg-clip-text text-transparent">
              In Minutes, For Free
            </span>
          </h1>
          
          <p className="text-lg sm:text-xl text-gray-600 max-w-2xl mx-auto">
            Join 50,000+ job seekers who've created ATS-friendly resumes with our easy-to-use builder
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
            <Link to="/resume" className="button-primary">
              <FileText className="h-5 w-5" />
              Create Your Resume
              <ArrowRight className="h-5 w-5" /> 
            </Link>
          </div>

          <div className="mt-8 flex flex-wrap justify-center gap-4 text-sm">
            <div className="flex items-center gap-2">
              <Sparkles className="h-5 w-5 text-teal-600" />
              <span>Free Forever</span>
            </div>
            <div className="flex items-center gap-2">
              <Shield className="h-5 w-5 text-teal-600" />
              <span>No Sign Up</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle className="h-5 w-5 text-teal-600" />
              <span>ATS-Friendly</span>
            </div>
          </div>
        </div>
      </div>

      {/* Background decoration */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-br from-teal-50 via-white to-teal-50 opacity-90" />
        <div className="absolute inset-0 opacity-5">
          <Image
            src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80"
            alt="Office background"
            sizes="100vw"
            className="w-full h-full object-cover"
            loading="eager"
          />
        </div>
      </div>
    </section>
  );
}